import {ACTION_POST_TEST_SUCCEEDED, ACTION_POST_TEST_FAILED} from "../actions/actionTypes";

export default function (state = [], action) {
    switch (action.type) {
        case ACTION_POST_TEST_SUCCEEDED:
            return action.data;
        case ACTION_POST_TEST_FAILED:
            return [];
        default:
            return [];
    }
}


// WEBPACK FOOTER //
// ./src/reducers/test_checked.js